<form [formGroup]="formGroup">
  <p-autoComplete
    #autocompleteRef
    [suggestions]="adreseSuggestions"
    formControlName="searchValue"
    field="nazivMagacina"
    (completeMethod)="searchMagacin($event)"
    (onSelect)="selectionChanged($event)"
    [placeholder]="ctrlPlaceholder"
    [appendTo]="parentCtrl"
    [forceSelection]="mustSelect"
    (onKeyUp)="nazivChanged($event)"
    (onClear)="onClear()"
    emptyMessage="Magacin nije pronađen"
    dropdownMode="current"
    [disabled]="ctrlDisabled"
    [styleClass]="isInvalid ? 'p-invalid' : ''"
  >
    <ng-template let-adresa pTemplate="item">
      <div class="stranka-item">
        <div>{{ adresa.nazivMagacina }}</div>
      </div>
    </ng-template>
  </p-autoComplete>
  <kodit-error-info-required
    [formCtrl]="formGroup.controls.searchValue"
  ></kodit-error-info-required>
</form>
